import {
  KYDAdminEvent,
  KYDAdminEventDetailSection,
} from "@common/interfaces/KYDEvent";
import { sectionsComponents } from "./sectionsComponents";
import { Box, Stack } from "@chakra-ui/react";
import { EditModalType } from "src/utils";
import React from "react";

class SectionErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Section Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box p={4} bg="red.50" color="red.600" borderRadius="md">
          Something went wrong rendering this section. Please try refreshing the
          page.
        </Box>
      );
    }

    return this.props.children;
  }
}

const EventDetailSections = ({
  sections = [],
  onUpdateEvent,
  setModalType,
  modalType,
  isLoading,
  refetchEvent,
  pollForEventUpdateStatus,
}: {
  sections: KYDAdminEventDetailSection[];
  modalType?: EditModalType;
  isLoading: boolean;
  onUpdateEvent: (key: string, override_value?: string) => Promise<void>;
  setModalType: (value: React.SetStateAction<EditModalType>) => void;
  refetchEvent?: (options: any) => Promise<KYDAdminEvent>;
  pollForEventUpdateStatus: () => Promise<boolean>;
}) => {
  return (
    <Stack spacing={{ base: "8", lg: "14" }}>
      {sections.map((section) => {
        const Component = sectionsComponents[section.type];
        if (!Component) {
          console.warn(
            `Skipping rendering ${section.type}. No component ${section.type} supported.`
          );
          return null;
        }

        return (
          <SectionErrorBoundary key={section.type}>
            <Component
              data={section.data}
              permissions={section.permissions}
              isLoading={isLoading}
              modalType={modalType}
              refetchEvent={refetchEvent}
              setModalType={setModalType}
              onUpdateEvent={onUpdateEvent}
              pollForEventUpdateStatus={pollForEventUpdateStatus}
            />
          </SectionErrorBoundary>
        );
      })}
    </Stack>
  );
};

export default EventDetailSections;
